module.exports = __webpack_public_path__ + "img/verifyandpay-blue.d72431ca.svg";